import { useRouter } from 'next/router';
import { useEffect } from 'react';
import Buyback from '@/components/buyback';
import { iPhonesList, usedIphones } from '@/settings/configs/buyback/au';
import settings from '@/settings';

export default function SellIPhone() {
  const router = useRouter();

  useEffect(() => {
    if (
      !settings.buyback_exist ||
      (settings.buyback_exist && settings.store === 'quista')
    )
      router.push('/buyback/sell-apple-iphone');
  }, [router]);

  const bannerData = {
    heading: `SELL YOUR IPHONE TODAY`,
    description: `Highest trade-in prices in ${settings.country} for Apple iPhones.`,
  };

  const customSEOText = {
    title: `Sell your Used iPhone`,
    description: `Sell your Used iPhone. You can sell any iPhone 14, iPhone 13, iPhone 12, iPhone 11, iPhone X, iPhone XS, iPhone XR, iPhone 8, iPhone 8 Plus and many other iPhones with Reebelo.`,
  };

  return (
    <Buyback
      brand="Apple iPhone"
      brandShort="Apple"
      bannerData={bannerData}
      title="iPhone"
      typeFormDevicesList={iPhonesList}
      customSEOText={customSEOText}
      priceTableList={usedIphones.map((val) => ({ title: val }))}
    />
  );
}
